import React, { useState } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioSms from "./components/RelatorioSms";
import RelatorioEmail from "./components/RelatorioEmail";
const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  { value: "sms", label: "Relatório de SMS" },
  { value: "email", label: "Relatório de Emails" },
];

const relatorioCaps = {
  sms: { gerar: true, exportar: true },
  email: { gerar: true, exportar: true },
};

function RelatoriosComunicacoes({ auth, clinica }) {
  const { sendRequest } = useHttpClient();
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    atualizacoes: 0,
  });

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) return;

    setDadosRelatorio((prev) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial, dataFinal },
      acao: "gerar",
      atualizacoes: prev.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) return;

    setDadosRelatorio((prev) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial, dataFinal },
      acao: "exportar",
      atualizacoes: prev.atualizacoes + 1,
    }));
  };

  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro,
      clinicaId: clinica.clinica._id,
      auth,
      acao,
      sendRequest,
      atualizacoes,
    };

    switch (open) {
      case "sms":
        return <RelatorioSms {...props} />;
      case "email":
        return <RelatorioEmail {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps}
        relatorioSelecionado={dadosRelatorio.open}
      />
      {renderizarRelatorio()}
    </>
  );
}

export default RelatoriosComunicacoes;
